<template>
  <div class="home">
    <div class="card-container">
      <v-card max-width="400px" class="home-card rounded-0">
        <v-card-title class="white primary--text mt-4 mb-12 px-10">
          <span class="text-no-wrap nav-font heading">Voyage</span>
        </v-card-title>
        <v-card-text class="px-10">
          <div v-if="!isUserLoggedIn" class="form-container">
            <LoginForm />
          </div>
          <div v-else>
            <v-list>
              <v-list-item-group color="primary">
                <v-divider />
                <div v-for="item in cardItems" :key="item.id">
                  <v-list-item :to="item.toRoute">
                    <v-list-item-icon>
                      <v-avatar color="primary">
                        <v-icon large color="white">{{ item.icon }}</v-icon>
                      </v-avatar>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        class="text-h6 text-start font-weight-medium"
                        >{{ item.title }}</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider />
                </div>
              </v-list-item-group>
            </v-list>
          </div>
          <div>
            <v-img
              class="my-12"
              :src="require('@/assets/peterson-logo.png')"
              alt="peterson logo"
              max-height="100"
              max-width="150"
              contain
            ></v-img>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import LoginForm from '@/components/home/LoginForm.vue';

export default {
  name: 'Home',
  components: {
    LoginForm,
  },
  data() {
    return {
      isActive: true,
      showHomePageImage: false,
      cardItems: [
        {
          id: 1, icon: 'mdi-eye', title: 'Overview', toRoute: '/vessel-overview',
        },
        {
          id: 2, icon: 'mdi-ferry', title: 'Voyages', toRoute: '/voyage-reports?tab=active',
        },
        {
          id: 3, icon: 'mdi-car-coolant-level', title: 'Tanks', toRoute: '/tanks',
        },
      ],
    };
  },
  computed: {
    ...mapState(['userStore', 'voyageReportsStore']),
    ...mapGetters({
      isClientConnectedToServer: 'userStore/isClientConnectedToServer',
      isUserLoggedIn: 'userStore/isUserLoggedIn',
      isUser: 'userStore/isUser',
      isAdmin: 'userStore/isAdmin',
      activeSiteId: 'userStore/getActiveSiteId',
    }),
  },
  watch: {
    isUserLoggedIn(newVal) {
      if (newVal === true && this.activeSiteId && this.isClientConnectedToServer) {
        this.loadAllSiteDataForInitialCache();
      }

      // When user is logged in - Go to most recent voyage report that is not marked as 'Complete'
      if (newVal && ((this.isUser && !this.isAdmin) && this.activeSiteId)) {
        this.redirectToMostRecentVoyage();
      }
    },
  },
  methods: {
    loginWithAadCookie() {
      this.$store.dispatch('userStore/loginWithAadCookie', {});
    },
    redirectToMostRecentVoyage() {
      this.$store.dispatch('voyageReportsStore/loadVoyageReports', this.activeSiteId).then(() => {
        const { voyageReports } = this.voyageReportsStore;
        let mostRecentReport = null;
        if (voyageReports) {
          [mostRecentReport] = voyageReports;
          if (mostRecentReport && mostRecentReport.status !== 'Completed') this.$router.push({ name: 'voyagedetails', params: { id: mostRecentReport.id } });
        }
      });
    },
    loadAllSiteDataForInitialCache() {
      this.$store.dispatch('vesselsStore/loadVessels', this.activeSiteId);
      this.$store.dispatch('locationsStore/loadVesselLocations', this.activeSiteId);
      this.$store.dispatch('voyageReportsStore/loadVoyageReports', this.activeSiteId);
      this.$store.dispatch('activitiesStore/loadAvailableActivities', this.activeSiteId);
      this.$store.dispatch('tanksStore/loadTankStatuses', this.activeSiteId);
      this.$store.dispatch('bulksStore/loadBulks', this.activeSiteId);
      this.$store.dispatch('bulksStore/loadBulkTypes');
      this.$store.dispatch('bulkTransactionsStore/loadBulkTransactionTypes');
    },
  },
  created() {
    if (!this.userStore.user) {
      this.loginWithAadCookie(); // Attempt login following redirect from /signin-oidc
    }

    if (this.isUserLoggedIn && this.activeSiteId) {
      this.loadAllSiteDataForInitialCache();
    }
  },
};
</script>

<style scoped>
.home {
  height: 100%;
  background-image: url("../assets/home_port.jpeg");
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
}

.home-card {
  border-top: 12px solid #1a2b59 !important;
}

.home-card:after {
  content: "";
  display: block;
  width: 90%;
  border-bottom: 12px solid red;
}

.home-card .heading {
  font-size: 48px;
  font-weight: bold;
}

.form-container {
  min-height: 260px;
}

.card-container {
  max-width: 400px;
  margin: 48px auto 0px auto !important;
}

@media only screen and (min-width: 1264px) {
  .card-container {
    margin: 48px 0px 0px 255px !important;
  }
}
</style>
